import { createFileRoute } from '@tanstack/react-router'
import { ShareConfig } from '~/features/webchat/components'
import { useWebchatEmbedScript } from '~/hooks/webchat'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/share')({
  component: Component,
})

function Component() {
  const { botId, workspaceId } = Route.useParams()

  const { embedScript, shareableLink } = useWebchatEmbedScript({ botId, workspaceId })

  return <ShareConfig embedScript={embedScript} shareableLink={shareableLink} />
}
